import type { IViewPortController } from '@/engine/app/interfaces';
import { useEffect } from 'react';

export const useResetCursorOnPointerLeave = (
  canvasRef: React.RefObject<HTMLCanvasElement>,
  controller: IViewPortController | undefined
): void => {
  useEffect(() => {
    const canvas = canvasRef.current;
    const resetCursor = (): void => {
      controller?.setCursor('');
    };
    canvas?.addEventListener('pointerleave', resetCursor);

    return (): void => {
      canvas?.removeEventListener('pointerleave', resetCursor);
    };
  }, [controller, canvasRef]);
};
